import {AccessDataService} from "../data/access-data.service";
import {AppPageApi2} from "../api/app-page.api";
import {RequestGetAllPageAccessibleModel, ResponseGetAllPageAccessibleModel} from "../../model/app-page.model";
import {Storage} from "@ionic/storage";
import {Injectable} from "@angular/core";

@Injectable()
export class PageAccessibleService {
  constructor(
    private accessDataService: AccessDataService,
    private appPageApi: AppPageApi2,
    private storage: Storage,
  ) {
  }


  async checkAccessible(pageId: string): Promise<any> {
    if (this.accessDataService.AllPageAccessible.data) {
      return new Promise(async (resolve, reject) => {
        let a = this.accessDataService.AllPageAccessible.data.find(element => element.pageCode === pageId)
        if (a) {
          resolve(a.result);
        } else {
          resolve(false)
        }
      })
    } else {
      return new Promise(async (resolve, reject) => {
        let auth = JSON.parse(await this.storage.get("SFGoAuth"))
        const data: RequestGetAllPageAccessibleModel = new RequestGetAllPageAccessibleModel();
        data.companyId = auth.companyId
        data.empId = auth.empId
        data.userAccess = JSON.parse(await this.storage.get("userAccessGroup"))
        console.log('masuk 1', data);
        this.appPageApi.getAllPageAccessible(data).then((result: ResponseGetAllPageAccessibleModel) => {
          try {
            this.accessDataService.AllPageAccessible = result
            let a = result.data.find(element => element.pageCode == pageId)
            if (a) {
              resolve(a.result);
            } else {
              resolve(false)
            }
          } catch (error) {
            resolve(false);
          }
        })
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/page-accessible.service.ts